import { driveSlikaUrl } from "./driveSlike.js";
import { parsirajCSV } from "./csv.js";

export const DVORANE_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vRDyFn9GQMcr8FmUlcWKPywaH74VAulekixZc3PcARVy0enw53H9-L34tx1DnLVbpZxPoNUwr77_cls/pub?output=csv";

export const REZERVNA_SLIKA_URL = "/photos/logo/virtus_logo_10.png";

const SIRINA_SLIKE_DVORANE = 1200;

function izvuciDriveId(url) {
  const match =
    url.match(/\/file\/d\/([^/]+)/) || url.match(/[?&]id=([^&]+)/);
  return match ? match[1] : null;
}

export function slikaIzLinka(link) {
  if (!link) return REZERVNA_SLIKA_URL;
  const id = izvuciDriveId(link);
  if (!id) return link.startsWith("http") ? link : REZERVNA_SLIKA_URL;
  return driveSlikaUrl(id, SIRINA_SLIKE_DVORANE);
}

function razdvojiPoZarezu(vrijednost) {
  return vrijednost
    .split(",")
    .map((dio) => dio.trim())
    .filter(Boolean);
}

const ZAMJENE_SLOVA = { č: "c", ć: "c", đ: "d", š: "s", ž: "z" };

function kljucStupca(ime) {
  return ime
    .trim()
    .toLowerCase()
    .replace(/[čćđšž]/g, (znak) => ZAMJENE_SLOVA[znak]);
}

/**
 * Stupci se traze po nazivu iz zaglavlja, ne po redoslijedu, da dodavanje ili
 * premjestanje stupca u tablici ne trazi izmjenu koda.
 */
function napraviCitac(zaglavlje) {
  const indeksi = {};
  zaglavlje.forEach((ime, i) => {
    indeksi[kljucStupca(ime)] = i;
  });

  return (redak, ...nazivi) => {
    for (const naziv of nazivi) {
      const i = indeksi[kljucStupca(naziv)];
      if (i !== undefined && redak[i]) return redak[i];
    }
    return "";
  };
}

/**
 * Stupac "Termini": jedan redak celije (Alt+Enter) po terminu, u obliku
 *
 *   1.-4. razred | Ponedjeljak, Petak | 15:00 - 16:00
 *
 * Isti razred moze imati vise redaka; na stranici se spajaju pod jedan naslov.
 */
function izStupcaTermini(vrijednost) {
  return vrijednost
    .split("\n")
    .map((redak) => redak.trim())
    .filter(Boolean)
    .map((redak) => {
      const [kategorija = "", dani = "", vrijeme = ""] = redak
        .split("|")
        .map((dio) => dio.trim());

      return { kategorija, dani: razdvojiPoZarezu(dani), vrijeme };
    })
    .filter((stavka) => stavka.dani.length > 0 || stavka.vrijeme);
}

/** Stariji zapis: tri usporedna stupca, n-ti dan uz n-to vrijeme i kategoriju. */
function izUsporednihStupaca(dani, vremena, kategorije) {
  const daniLista = razdvojiPoZarezu(dani);
  const vremenaLista = razdvojiPoZarezu(vremena);
  const kategorijeLista = razdvojiPoZarezu(kategorije);

  return daniLista.map((dan, i) => ({
    kategorija: kategorijeLista[i] || "",
    dani: [dan],
    vrijeme: vremenaLista[i] || "",
  }));
}

function grupirajPoKategoriji(stavke) {
  const grupe = [];

  for (const stavka of stavke) {
    let grupa = grupe.find((g) => g.kategorija === stavka.kategorija);

    if (!grupa) {
      grupa = { kategorija: stavka.kategorija, stavke: [] };
      grupe.push(grupa);
    }

    grupa.stavke.push({ dani: stavka.dani, vrijeme: stavka.vrijeme });
  }

  return grupe;
}

/** ["Ponedjeljak", "Srijeda", "Petak"] -> "Ponedjeljak, Srijeda i Petak" */
export function spojiDane(dani) {
  if (dani.length < 2) return dani.join("");
  return `${dani.slice(0, -1).join(", ")} i ${dani[dani.length - 1]}`;
}

export function parseDvoraneCSV(csvTekst) {
  const [zaglavlje = [], ...redci] = parsirajCSV(csvTekst);
  const uzmi = napraviCitac(zaglavlje);

  return redci
    .map((redak, index) => {
      const ime = uzmi(redak, "Ime", "Naziv");
      if (!ime) return null;

      const adresa = uzmi(redak, "Adresa");
      const jeLink = adresa.startsWith("http");
      const googleMapsLink = jeLink
        ? adresa
        : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(adresa)}`;
      const lokacija = jeLink ? "Prikaži lokaciju na karti" : adresa;

      const stupacTermini = uzmi(redak, "Termini");
      const stavke = stupacTermini
        ? izStupcaTermini(stupacTermini)
        : izUsporednihStupaca(
            uzmi(redak, "Dani treninga"),
            uzmi(redak, "Termin treninga"),
            uzmi(redak, "Kategorije"),
          );

      return {
        id: index + 1,
        naziv: ime,
        lokacija,
        googleMapsLink,
        slika: slikaIzLinka(uzmi(redak, "Slike", "Slika")),
        termini: grupirajPoKategoriji(stavke),
      };
    })
    .filter(Boolean);
}
